import getLangKey from '../../../utils/getLangKey';
import { getPortalId } from '../../../utils/getPortalId';
import { captureException } from '../../../utils/sentryAPI';
import { NotificationsError } from '../errors';
export const getApiConfigs = () => {
  const portalId = getPortalId();
  const locale = getLangKey();
  const queryConfig = {
    query: {
      portalId
    }
  };
  return {
    queryConfig,
    locale
  };
};
export const captureUndefinedPortalError = () => captureException(new NotificationsError('portalId not defined'));